/**
 * @generated SignedSource<<795975b5d962918bc9e67cdc08080690>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type MemberTeamRow_team$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type PipelineNewTeams_organization$fragmentType: FragmentType;
export type PipelineNewTeams_organization$data = {|
  +teams: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +permissions: {|
          +pipelineView: ?{|
            +allowed: boolean,
          |},
          +teamPipelineCreate: ?{|
            +allowed: boolean,
          |},
        |},
        +uuid: string,
        +$fragmentSpreads: MemberTeamRow_team$fragmentType,
      |},
    |}>,
  |},
  +$fragmentType: PipelineNewTeams_organization$fragmentType,
|};
export type PipelineNewTeams_organization$key = {
  +$data?: PipelineNewTeams_organization$data,
  +$fragmentSpreads: PipelineNewTeams_organization$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "allowed",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PipelineNewTeams_organization",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 500
        }
      ],
      "concreteType": "TeamConnection",
      "kind": "LinkedField",
      "name": "teams",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MemberTeamRow_team"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uuid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TeamPermissions",
                  "kind": "LinkedField",
                  "name": "permissions",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Permission",
                      "kind": "LinkedField",
                      "name": "pipelineView",
                      "plural": false,
                      "selections": (v0/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Permission",
                      "kind": "LinkedField",
                      "name": "teamPipelineCreate",
                      "plural": false,
                      "selections": (v0/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "teams(first:500)"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "019436a01df7835397db49822a27eae7";

module.exports = ((node/*: any*/)/*: Fragment<
  PipelineNewTeams_organization$fragmentType,
  PipelineNewTeams_organization$data,
>*/);
